import { el } from '../utils/dom.js';

/**
 * Export the current map as a PNG image.
 */
export class ExportImageDialog {
  constructor(state, mapCanvas) {
    this.state = state;
    this.mapCanvas = mapCanvas;
  }

  export() {
    const state = this.state;
    const mapW = state.get('mapWidth');
    const mapH = state.get('mapHeight');
    const tileW = state.get('tileWidth');
    const tileH = state.get('tileHeight');
    const layers = state.get('layers');
    const width = mapW * tileW;
    const height = mapH * tileH;

    // Render all visible layers to a single canvas
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');

    for (let i = 0; i < layers.length; i++) {
      const layer = layers[i];
      if (!layer.visible || layer.type !== 'tilelayer') continue;

      const layerCanvas = this.mapCanvas.renderFullLayer(i);
      if (layerCanvas) {
        ctx.globalAlpha = layer.opacity ?? 1;
        ctx.drawImage(layerCanvas, layer.offsetX || 0, layer.offsetY || 0);
        ctx.globalAlpha = 1;
      }
    }

    // Download
    const fileName = (state.get('fileName') || 'map').replace(/\.(tmj|json)$/i, '') + '.png';

    canvas.toBlob((blob) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(url);
    }, 'image/png');
  }
}
